import { FundSourceTypeEnum } from './fund-source-type-enum';
import { BankAccountStatusEnum } from './bank-account-status-enum';

export interface IFundSource {
    /**
     * Amount taken from the fund source.
     */
    readonly amount?: number;
    /**
     * Indicates whether the fund source is disabled from payments
     */
    readonly disabledFromPayments?: boolean;
    /**
     * A unique ID that can be passed to the purchase API to identify the fund source to use.
     */
    readonly fundSourceId?: number;
    /**
     * The user-provided label, if the user entered one for this fund source, or a generic label like "Visa credit card" otherwise.
     */
    readonly label?: string;
    /**
     * The URL to the card or bank logo. API clients should not assume any fixed dimensions,
     * but instead scale the image to fit the space available. Logos are likely to be either square or wider than they are tall.
     */
    readonly logo?: string;
    /**
     * A string containing the card or bank account number, with most of the digits blacked out for privacy reasons
     * (e.g. "**** **** **** 1234" for a CC or "12 3456 ****789 00" for a bank account).
     */
    readonly maskedAccountNumber?: string;
    /**
     * This represents the expiration date for a credit card set for single use only.
     */
    readonly singleUseExpiry?: Date;
    /**
     * The type of fund source. If the type is unrecognised, the API client should ignore this fund source and move
     * on to the next one.
     */
    readonly type?: FundSourceTypeEnum;
    /**
     * The date of the last sent verification code or null if a verification code has not been sent.
     * This will be null if either no verification is required(see Status) or the batch payment process that includes
     * the verification code for this fund source has not yet run(currently once per business day).
     */
    readonly verificationCodeCreationDate?: Date;
    /**
     * The verification status of a bank account. Not applicable for credit/debit card fund sources.
     */
    readonly verificationStatus?: BankAccountStatusEnum;
}
